import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import {
  IonButton,
  IonCheckbox,
  IonCol,
  IonTextarea,
  IonIcon,
  IonGrid,
  IonItem,
  IonLabel,
  IonModal,
  IonRow,
  IonSearchbar,
  IonAlert,
} from "@ionic/react";

import { close } from "ionicons/icons";
import { CONSTANTS, ERROR } from "../../../constants";
import DoctorList from "../../Shared/DoctorList/doctor-list";
import { doctorListInputData } from "../../Shared/DoctorList/doctor-list.model";
import { utilService } from "../../../services/utilService";
import "./GroupSms.scss";
import { groupSmsService } from "./GroupSms.service";
import { useToast } from "@agney/ir-toast";
import { SendGroupSmsResp } from "../GroupSms/GroupSms.model";
import { rolePermissionsService } from "../../../services/rolePermissions.service";

interface sendSmsProps {
  showModal: boolean;
  onCancel: () => void;
  onOk: () => void;
  doctorListDataFromParent: any;
}

const GroupSms: React.FC<sendSmsProps> = (props) => {
  const { t } = useTranslation("home");
  const [searchText, setSearchText] = useState("");
  const [comment, setComment] = useState<string>("");
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [sendSmsSubmitData, setSendSmsSubmitData] = useState<any>(Object);
  const [isSelectAll, setSelectAll] = useState(false);
  const [selectedDoctorCard, setSelectedDoctorDetails]: any = useState([]);
  const [isShowAlert, setIsShowAlert] = useState(false);
  var [currentErrorMessage, setCurrentErrorMessage]: any = useState();
  var [isInputEmpty, setIsInputEmpty] = useState(true);
  var [selectedAllStatus, setSelectedAllStatus] = useState(false);
  var [disableSendButton, setDisableSendButton] = useState(true);
  var [apiParams, setApiParams]: any = useState({});
  const [isSmallScreen, setIsSmallScreen]: any = useState(false);
  const [doctorData, setDoctorData]: any = useState([]);

  const Toast = useToast();

  useEffect(() => {
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
    checkIfSmallScreen();
  }, []);

  useEffect(() => {
    setDoctorData(props.doctorListDataFromParent);
  }, [props.doctorListDataFromParent]);

  useEffect(() => {
    disableGroupSmsButton();
  }, [isInputEmpty, selectedDoctorCard]);

  useEffect(() => {
    if (selectedAllStatus === true) {
      setSelectAll(true);
    }
  }, [selectedAllStatus]);

  async function sendGroupSms() {
    const params: any = getGroupSmsApiParams();

    const respSendSmsResult: SendGroupSmsResp =
      await groupSmsService.sendGroupSms(params);
    if (respSendSmsResult.isSuccess) {
    } else {
      console.log("error");
      groupSmsService.handleErrorResponse();
    }
    setSendSmsSubmitData(respSendSmsResult);
    showApiResponse(respSendSmsResult);
  }

  const getGroupSmsApiParams = () => {
    return {
      message_sms: comment,
      reg_code: utilService.getNetwork(),
      time: utilService.getCurrentDateAndTime(),
      users: getSelectedGuid(),
    };
  };

  const getSelectedGuid = () => {
    const selectedIds: any = [];
    selectedDoctorCard.map((item: any) => {
      selectedIds.push(item.guid);
    });
    return selectedIds;
  };

  const selectAll = async (event: any) => {
    setSelectAll(event.detail.checked);
  };

  const getSelectedCard = (selectedCard: any) => {
    setSelectedDoctorDetails([...selectedCard]);
  };

  const disableGroupSmsButton = () => {
    if (isInputEmpty || !selectedDoctorCard.length) {
      setDisableSendButton(true);
    } else {
      setDisableSendButton(false);
    }
  };

  const getSelectAllStatus = (selectedAllStatusFromDoctorList: boolean) => {
    console.log(selectedAllStatusFromDoctorList);
    setSelectedAllStatus(selectedAllStatusFromDoctorList);
  };

  const showApiResponse = (sendSmsData: any) => {
    if (sendSmsData.status !== 200) {
      setCurrentErrorMessage(ERROR.sendSms.SMS_SENDING_FAILED);
      setIsShowAlert(true);
    } else if (sendSmsData.status === 200) {
      Toast.success(CONSTANTS.MESSAGES.GROUP_SMS_SUCCESS);
    }
  };

  const doctorListInput: doctorListInputData = {
    componentName: CONSTANTS.COMPONENTS.GROUP_SMS,
    isMultiSelectEnabled: true,
    isShowColorBadge: false,
  };

  const setMessageOnSendButtonClick = () => {
    sendGroupSms();
  };

  const checkIfSmallScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  const checkIfInputEmpty = () => {
    const isWhitespace = utilService.checkIfInputEmpty("groupSmsText");
    setIsInputEmpty(isWhitespace);
  };

  return (
    <div>
      <IonAlert
        isOpen={isShowAlert}
        onDidDismiss={() => setIsShowAlert(false)}
        cssClass="sms-alert"
        message={currentErrorMessage}
        buttons={[
          {
            text: t("ok"),
            handler: () => {
              setIsShowAlert(false);
            },
          },
        ]}
      />
      <IonModal
        isOpen={props.showModal}
        backdropDismiss={false}
        className="group-sms-modal"
      >
        <div className="group-sms-modal-container">
          <div
            className={`close-modal-icon ${
              isSmallScreen && "close-modal-icon-small-screen"
            }`}
            onClick={() => {
              props.onCancel();
              setComment("");
              setIsInputEmpty(true);
              setSelectAll(false);
              setSearchText("");
            }}
          >
            <IonIcon icon={close} />
          </div>

          <div
            className={`group-sms-content ${
              isSmallScreen && "group-sms-content-small-screen"
            }`}
          >
            <div className="group-sms-header">{t("groupSmsHeader")}</div>

            <div className="searchbar-container">
              <div className="select-all-button">
                <IonItem lines="none">
                  <IonCheckbox
                    className="check-box"
                    onIonChange={(event) => selectAll(event)}
                  ></IonCheckbox>
                  <IonLabel>{t("all")}</IonLabel>
                </IonItem>
              </div>
              <div className="searchbar-containar-item">
                <IonSearchbar
                  value={searchText}
                  onIonChange={(e) => setSearchText(e.detail.value!)}
                  placeholder={t("search")}
                  type="search"
                  autocomplete="off"
                  autoCorrect="off"
                  className="searchbar"
                ></IonSearchbar>
              </div>
            </div>

            <div className="doctor-card-list-container">
              <IonGrid className="scrollbar">
                <IonRow>
                  <IonCol>
                    <DoctorList
                      apiParams={apiParams}
                      doctorListInputData={doctorListInput}
                      permissions={rolePermissions}
                      selectedAll={isSelectAll}
                      searchText={searchText}
                      doctorListDataFromParent={doctorData}
                      getSelectedCard={getSelectedCard}
                      getSelectedCardAndSchedule={() => {}}
                      getIsAllSelectedStatus={getSelectAllStatus}
                      getAllCards={() => {}}
                      getAllCardsAndSchedule={() => {}}
                      hideFeatureButtons={true}
                      isFullScreen={false}
                    ></DoctorList>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </div>

            <div className="comment-box">
              <IonTextarea
                className="textarea-div"
                value={comment}
                maxlength={250}
                placeholder={t("groupSmsMessagePlaceholder")}
                id="groupSmsText"
                onIonChange={(e) => {
                  checkIfInputEmpty();
                  setComment(e.detail.value!);
                }}
              ></IonTextarea>
            </div>

            <div className="group-sms-button-container">
              <div className="cancel-button-div">
                <IonButton
                  color="medium"
                  className="button secondary-btn  btn-curved"
                  onClick={() => {
                    props.onCancel();
                    setComment("");
                    setIsInputEmpty(true);
                    setSelectAll(false);
                    setSearchText("");
                  }}
                >
                  {t("cancel")}
                </IonButton>
              </div>
              <div className="send-button-div">
                <IonButton
                  className="submit-btn button primary-btn btn-curved"
                  disabled={disableSendButton}
                  onClick={() => {
                    setMessageOnSendButtonClick();
                    setComment("");
                    props.onCancel();
                    setIsInputEmpty(true);
                    setSelectAll(false);
                    setSearchText("");
                  }}
                >
                  {t("send")}
                </IonButton>
              </div>
            </div>
          </div>
        </div>
      </IonModal>
    </div>
  );
};

export default GroupSms;
